import {Component, ElementRef, ViewChild, OnInit} from '@angular/core';
import { CommunicationService } from '../../services/communication.service';
import {SCREEN_SIZE, ListingCategory, DirectoryTypes, ListingPurchase} from '../../classes/enums';
import { HasSubscriptions } from '../has-subscriptions';
import {ListingsService} from "../../services/listings.service";
import {Pagination} from "../../classes/pagination";
import {DirectoryLinksListing} from "../../classes/directory-links-listing";
import {DomManipulationService} from "../../services/dom-manipulation/dom-manipulation.service";
import {ActivatedRoute} from "@angular/router";
import {MetaTagService} from "../../services/meta-tag.service";

@Component({
  selector: 'app-listing-sitemap',
  templateUrl: './listing-sitemap.component.html',
  styleUrls: ['./listing-sitemap.component.scss']
})
export class ListingSitemapComponent extends HasSubscriptions implements OnInit {

  links: DirectoryLinksListing[];
  pagination = new Pagination(0, 75);
  currentListingType: ListingCategory;
  @ViewChild('sitemapLinksList') alElementRef: ElementRef;
  screenSize: SCREEN_SIZE;

  constructor(
    private communicationService: CommunicationService,
    private listingsService: ListingsService,
    private domManipulationService: DomManipulationService,
    private activatedRoute: ActivatedRoute,
    private metaTagService: MetaTagService) {
    super();
    this.addSub(this.communicationService.screenSize.subscribe((s) => this.screenSize = s));
  }

  ngOnInit() {
    this.addSub(this.communicationService.listings.currentShownListingType.subscribe((listingType) => {
      this.currentListingType = listingType;
    }));

    this.activatedRoute.queryParams.subscribe(s => {
      let pageNumber = Number(s.page) || 0; // For Pagination
      // We need to remember to decrement this value as pagination arrays start from 0
      if (pageNumber > 0) pageNumber--;
      this.getDirectoryLinks(pageNumber);
    });

    this.setSEOItems();
  }

  getDirectoryLinks(newPageNumber: number) {
    this.pagination.pageNumber = newPageNumber;
    let listingTypes = [this.currentListingType]; 

    this.listingsService.searchListingsSitemap(listingTypes, ListingPurchase.SALE, this.pagination).subscribe((result) => {
      this.pagination.setTotalResults(result.totalHits);
      this.links = result.results;
      this.domManipulationService.scrollIntoView(this.alElementRef, true);
    });
  }

  setSEOItems() {
    const titleVariables = {};
    const descriptionVariables = {};
    const titleString = "listing-sitemap.meta-tags.title";
    const descriptionString = "listing-sitemap.meta-tags.description";

    this.metaTagService.setPageTitle(titleString, titleVariables);
    this.metaTagService.setPageDescription(descriptionString, descriptionVariables);

    const openGraphTags: any = [
      {
        name: 'title',
        content: titleString,
        variables: titleVariables,
        isTranslateKey: true
      },
      {
        name: 'description',
        content: descriptionString,
        variables: descriptionVariables,
        isTranslateKey: true
      }
    ];

    this.metaTagService.setOpenGraphTags(openGraphTags);
  }
}
